import useQueryURL from "../../../../../common/hooks/useQueryURL";
import { useSingleChargePoint } from "../../../hooks/useChargePoint";
import ModalDrawer from "../../../../../common/components/organisme/ModalDrawer/ModalDrawer";
import ConnectorListPresenter from "../../ConnectorList/ConnectorList/ConnectorListPresenter";
import SectionTitle from "../../../../../common/components/atom/SectionTitle/SectionTitle";
import AddNewConnectorBtnModal from "../../NewConnector/AddNewConnectorBtnModal/AddNewConnectorBtnModal";
import { JWayIcon } from "../../../../../common/assets/JWayIcons";
import TextBox from "../../../../../common/components/molecule/TextBox/TextBox";
import SingleHardware from "../../../../hardwares/components/SingleHardware";

import { LoaderSreen } from "../../../../../common/components/molecule/Loader/Loader";
import ErrorScreenApp from "../../../../errorHandler/components/ErrorScreenApp/ErrorScreenApp";
import SingleChargePoint from "..";

export interface SingleChargeInfoPresenterProps {
  stationId?: string;
  chargePointId?: string;
}



export const ChargePointName = () => {
  const {singleChargePointQuery: {isError, isLoading, data}} = useSingleChargePoint({});

  if (isLoading) {
    return <>...</>
  }
  if (isError) {
    return <>-</>
  }
  return <>{data?.charge_point_name}</>
}

export interface SingleChargePointModalProps {
  stationId?: string;
  chargePointId?: string;
}
export const SingleChargePointModal = ({
  stationId,
  chargePointId,
}: SingleChargePointModalProps) => {
  const { removeQueryValue } = useQueryURL();
  const {singleChargePointQuery: {isError, isLoading, data, error}} = useSingleChargePoint({});

  if (isLoading) {
    return <LoaderSreen heigth={"100px"} />
  }

  if (isError) {
    return <ErrorScreenApp axiosError={error} />
  }
  return (
    <ModalDrawer
      urlParamName="singleChargePoint"
      titleRender={<div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10}}><JWayIcon type="thunder" size={16} color="#303030"/>Borne: <ChargePointName /></div>}
      onClose={() => {
        removeQueryValue(["chargePointId", "singleChargePoint"]);
      }}
    >
      <div style={{ height: "130px", marginBottom: "50px", display: "flex", gap: "20px" }}>
      <TextBox  content={[{
        title: "Nom",
        TextRender: () => <SingleChargePoint.Info  info="charge_point_name" />,
      }]} />
      <TextBox  content={[{
        title: "Device ID",
        TextRender: () => <SingleHardware.Info id={data?.charge_point_hardware_id} info="hardware_device_id" />,
      },
      {
        title: "Firmware version",
        TextRender: () => <SingleChargePoint.Info info="charge_point_firmware_version" />,
      }
      ]} />
      </div>
      <div style={{height: 30}} />
      <div style={{ marginTop: "20px", display: "flex", justifyContent: "space-between" }}>
        <SectionTitle iconType={"electric-car-plug"}>liste des connectors</SectionTitle>
        <AddNewConnectorBtnModal />
      </div>

      <ConnectorListPresenter />
    </ModalDrawer>
  );
};


